const migrations = {
        0: () => {
            return {};
        },
        1: () => {
            return {};
        },
        // 2 and 3 added together with the version bump below (2 -> 4) so that no matter which
        // version a given browser's cached state is currently sitting at, at least one of these
        // wipes it clean on the next load - a stale/mismatched shape from before a backend or
        // frontend change is otherwise invisible to redux-persist (it isn't a crash, so nothing
        // else here would catch it) and just keeps rehydrating as-is, looking broken until
        // someone knows to log out and back in.
        2: () => {
            return {};
        },
        3: () => {
            return {};
        }
    }
    // TEMPLATE
    // 1: (state) => {
    //     // migration to keep only device state
    //     return {
    //         device: state.device
    //     }
    // }

export default migrations;
